module.exports = __webpack_public_path__ + "static/media/logo.59151bd4.png";